"use strict";

(function () {
  "use strict";

  var log = debug("component:headerLine");

  angular.module("common").directive("headerLine", tableLine);

  function tableLine() {
    var directive = {
      restrict: "EA",
      scope: {
        isSuperAdmin: "=?",
        isSuper: "=?",
        isLvr: "=?",
        isAdmin: "=?",
        create: "=?",
        createSlot: "=?",
        createClosedSlot: "=?",
        openLastDepaForm: "=?",
        openInsurerContracts: "=?",
        openActionHistory: "=?",
        openDocumentRequests: "=?",
        refresh: "=",
        displayPeriod: "=?",
        onPeriod: "=?",
        smartTablePageSize: "=",
        filterTags: "=",
        export: "=",
        exportHeader: "=",
        period: "=?",

        otherActionsTemplateUrl: "=?"
      },
      template: "\n\n                <div class=\"header-table-flex\">\n\n                        <button id=\"createButton\" ng-if=\"vm.create\" type=\"button\" style=\"margin-left:8px;margin-right:8px\" class=\"btn btn-custom pull-right\" ng-click=\"vm.create()\"><span class=\"fa fa-plus\"></span> Cr\xE9er</button>\n                        <button id=\"createSlotButton\" ng-if=\"vm.createSlot && vm.isSuper\" type=\"button\" style=\"margin-left:8px;margin-right:8px\" class=\"btn btn-custom pull-right\" ng-click=\"vm.createSlot()\"><span class=\"fa fa-plus\"></span> Cr\xE9er un cr\xE9neau</button>\n                        <button id=\"createClosedSlotButton\" ng-if=\"vm.createClosedSlot && vm.isSuper\" type=\"button\" style=\"margin-left:8px;margin-right:8px\" class=\"btn btn-custom pull-right\" ng-click=\"vm.createClosedSlot()\"><span class=\"fa fa-lock\"></span> Fermer une p\xE9riode</button>\n                        <button ng-if=\"vm.openLastDepaForm && vm.isLvr\" type=\"button\" style=\"margin-left:8px;margin-right:8px\" class=\"btn btn-custom pull-right\" ng-click=\"vm.openLastDepaForm()\"><span class=\"fa fa-volume-control-phone\"></span> Rouvrir le questionnaire</button>\n\n                        <i class=\"fa fa-search\" style=\"margin-left:8px;margin-right:8px\"></i>\n\n                        <ol ng-if=\"vm.onPeriod\" id=\"singleSelection\" class=\"nya-bs-select\" ng-model=\"vm.period\" style=\"width:150px\" ng-change=\"vm.checkDate()\">\n\n\n                        <li class=\"nya-bs-option\" data-value=\"last12Months\">\n                            <a>12 derniers mois</a>\n                        </li>\n\n                        <li class=\"nya-bs-option\" data-value=\"last6Months\">\n                            <a>6 derniers mois</a>\n                        </li>\n\n                        <li class=\"nya-bs-option\" data-value=\"last3Months\">\n                            <a>3 derniers mois</a>\n                        </li>\n\n                        <li class=\"nya-bs-option\" data-value=\"currentMonth\">\n                            <a>Mois en cours</a>\n                          </li>\n\n                          <li class=\"nya-bs-option\" data-value=\"previousMonth\">\n                            <a>Mois pr\xE9c\xE9dent</a>\n                          </li>\n                          <li class=\"nya-bs-option\" data-value=\"year\">\n                            <a>Ann\xE9e en cours</a>\n                          </li>\n                          <li class=\"nya-bs-option\" data-value=\"previousYear\">\n                          <a>Ann\xE9e pr\xE9c\xE9dente</a>\n                        </li>\n                          <li class=\"nya-bs-option\" data-value=\"period\">\n                            <a>P\xE9riode</a>\n                          </li>\n                        </ol>\n\n                        <div ng-if=\"vm.period == 'period'\" style=\"margin-left:8px;width: 200px\">\n                          <bs-date-picker  date=\"vm.from\" on-change=\"vm.onFrom(value)\" onkeydown=\"return false\"></bs-date-picker>\n                        </div>\n                        <div ng-if=\"vm.period == 'period'\" style=\"margin-left:8px;width: 200px\">\n                          <bs-date-picker  date=\"vm.to\" on-change=\"vm.onTo(value)\" onkeydown=\"return false\"></bs-date-picker>\n                        </div>\n\n                        <div class=\"header-table-space\">\n                        <tags-input id=\"filter-tags\" class=\"bootstrap\" ng-model=\"vm.filterTags \" placeholder=\"Ajouter un filtre \" min-length=\"1\" replace-spaces-with-dashes=\"false \">\n\n                        </tags-input>\n\n                        </div>\n                        <button ng-if=\"vm.openInsurerContracts && vm.isAdmin\" type=\"button\" style=\"margin-left:8px;margin-right:8px\" class=\"btn btn-custom pull-right\" ng-click=\"vm.openInsurerContracts()\"><span class=\"fa fa-edit\"></span> Contrats d'assurance</button>\n                        <button ng-if=\"vm.openDocumentRequests\" type=\"button\" style=\"margin-left:8px;margin-right:8px\" class=\"btn btn-custom pull-right\" ng-click=\"vm.openDocumentRequests()\"><span class=\"fa fa-edit\"></span> Documents en attente</button>\n                        <button ng-if=\"vm.openActionHistory && vm.isSuperAdmin\" type=\"button\" style=\"margin-left:8px;margin-right:8px\" class=\"btn btn-custom pull-right\" ng-click=\"vm.openActionHistory()\"><span class=\"fa fa-book\"></span> Voir les acc\xE8s (7 derniers jours)</button>\n\n                        <button tooltip-placement=\"top\" uib-tooltip=\"Recharger les donn\xE9es\" id=\"refresh\" style=\"margin-left:8px;margin-right:8px\" type=\"button\" class=\"btn btn-custom pull-right\" ng-click=\"vm.refresh()\"><span class=\"fa fa-refresh\"></span> Recharger</button>\n\n                        <button ng-if=\"vm.otherActionsTemplateUrl\" uib-popover-template=\"vm.otherActionsTemplateUrl\" class=\"btn btn-default\" popover-placement=\"left\">...</button>\n                </div>\n\n\n            <script type=\"text/ng-template\" id=\"otherActions.html\">\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\">\n              <button type=\"button\" class=\"btn btn-default btn-with-icon\" ng-csv=\"vm.export()\" csv-header=\"vm.exportHeader()\" filename=\"export.csv\" field-separator=\";\" decimal-separator=\",\"><i class=\"ion-refresh\"></i>Exporter en csv</button>\n              </div>\n\n            </div>\n\n            </script>\n\n            ",
      controller: Controller,
      controllerAs: "vm",
      bindToController: true
    };
    return directive;
  }

  function Controller() {
    var vm = this;

    vm.period = !vm.period ? "last12Months" : vm.period;

    log("vm.otherActionsTemplateUrl", vm.otherActionsTemplateUrl);

    vm.checkDate = function () {
      console.log("check period", vm.period);

      if (vm.period === "last12Months") {
        vm.from = moment().subtract(12, "months").startOf("month").toDate();
        vm.to = moment().endOf("month").toDate();
      } else if (vm.period === "last6Months") {
        vm.from = moment().subtract(6, "months").startOf("month").toDate();
        vm.to = moment().endOf("month").toDate();
      } else if (vm.period === "last3Months") {
        vm.from = moment().subtract(3, "months").startOf("month").toDate();
        vm.to = moment().endOf("month").toDate();
      } else if (vm.period === "currentMonth") {
        vm.from = moment().startOf("month").toDate();
        vm.to = moment().endOf("month").toDate();
      } else if (vm.period === "previousMonth") {
        vm.from = moment().subtract(1, "months").startOf("month").toDate();
        vm.to = moment().subtract(1, "months").endOf("month").toDate();
      } else if (vm.period === "year") {
        vm.from = moment().startOf("year").toDate();
        vm.to = moment().endOf("year").toDate();
      } else if (vm.period === "previousYear") {
        vm.from = moment().subtract(1, "years").startOf("year").toDate();
        vm.to = moment().subtract(1, "years").endOf("year").toDate();
      } else if (vm.period === "period" && vm.from && vm.to) {
        if (vm.from.getTime() > vm.to.getTime()) {
          var swap = vm.from;
          vm.from = vm.to;
          vm.to = swap;
        }
      }

      if (vm.onPeriod) {
        log("call onPeriod");
        vm.onPeriod({
          from: moment(vm.from).startOf("day").toDate(),
          to: moment(vm.to).endOf("day").toDate()
        });
      }

      log("from", vm.from);
      log("to", vm.to);
    };

    vm.checkDate();

    vm.onFrom = function (date) {
      vm.from = date;
      vm.checkDate();
    };

    vm.onTo = function (date) {
      vm.to = date;
      vm.checkDate();
    };
  }
})();